import React from 'react';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import moment from 'moment';
import Joi from 'joi-browser';
// eslint-disable-next-line no-unused-vars
import parts from '../utilities/parts';

import { MachineryUseForm } from '../components/forms/MachineryUses';
import Confirmation from '../components/modals/common/Confirmation';
import { FieldItemInputService } from '../services/FieldItemInputs';
import { FieldService } from '../services/Fields'; // 現場マスタAPI
import { FieldItemService } from '../services/FieldItems'; // 現場作業エリア情報取得API
import { MachineryService } from '../services/Machineries'; // 機材マスタAPI
import { MachineryUseService } from '../services/MachineryUses'; // 機材予定API
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  WORK_HOUR_ZONES, // 作業時間帯
  SPOT_STATUS, // スポット利用ステータス
  SPOT_TIMES_DEFAULT,
  SCHEDULE_TYPES, // 予定種別
  HEADER_CONSTANTS, // ヘッダータイトル
  APPROVAL_STATUS, // 承認ステータス
  USER_ROLES_IDS,
  EXTERNAL_SYSTEM_TYPE,
  PRIVATE_PARTNER_COMPANY_LABEL,
} from '../utilities/constants'; // 定数ファイル
import EventMg from '../utilities/EventManager';
import { messageUtility } from '../utilities/messageUtility';
import { isTargetRoleId } from '../utilities/roleUtility';
import { isNullOrEmpty, deleteControlCode } from '../utilities/stringUtil';
import _slideLoader from '../utilities/slideLoader';
import { validateByJoi } from '../utilities/validation';
import {
  isCopyLatestError,
  isPrimeContractorHasBlockedOrFinishedWorkError,
  isWorkDateError,
} from '../utilities/apiErrorMessage';
import dialogLoader from '../utilities/dialogLoader';
import { ErrorDialog } from '../components/dialogs/ErrorDialog';
import { ConferencePageHeader } from '../components/PageHeader';
import { FormInformationDialog } from '../components/FormInformationDialog';

const MY_EVENT = {
  LOAD_MACHINERY_USES_DATA: 'load_machinery_uses_data', // 一覧取得
};

// ダイアログ名
const DIALOG_NAME = {
  close: 'close', // クローズ
  delete: 'delete', // 削除
  copy: 'copy', // コピー
};

/**
 * @description 機材予定登録・編集画面
 */
export class MachineryUseRegister extends React.Component {
  constructor(props) {
    super(props);

    const date_from = !_.isUndefined(this.props.view.state.currentDate)
      ? this.props.view.state.currentDate
      : !_.isNull(sessionStorage.getItem('date_from'))
      ? sessionStorage.getItem('date_from')
      : moment().format('YYYY/MM/DD');

    this.state = {
      machineryUseId: this.props.view.state.id, // 機材予定ID
      fieldId: SessionStorageService.getFieldId(), // 現場ID
      roleId: LocalStorageService.getRoleId(), // ロールID
      workTime: {}, // 現場に設定されている作業時間を格納
      // props.view.state.idは機材予定画面で選択したレコードのIDが入る(slideLoader.js publishView)
      isEdit: Number(this.props.view.state.id) > 0 ? true : false, // 編集中フラグ
      isFirstLoaded: false, // 初回ロードフラグ
      viewOnlyFlag: this.props.view.state.viewOnlyFlag, // 閲覧制限フラグ
      visibleDialogName: null, // 開閉用ダイアログ名
      requiredInput: {
        columns: [
          'use_date_start',
          'field_tree_id',
          'machinery_type',
          'machinery_id',
          'use_time',
        ], // 必須入力項目名
        hasSpot: [
          'use_date_start',
          'spot_company_name',
          'machinery_type',
          'machinery_id',
          'use_time',
        ], // スポット業者あり必須入力項目名
        count: 1, // 期間は初期セット
        total: 5, // 必須項目数
      },
      validate: {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      isSpot: false, // スポット利用（フォームの切り替えで使用）
      isSpotToggle: false, // スポット業者切替フラグ
      itemNames: [], // 作業場所情報
      options: {}, // プルダウン初期表示用データ
      loaded: false, // プルダウンの情報が取得できたか
      // プルダウンの初期name
      pulldownName: {
        company_name: '', // 協力会社名
        job_name: '', // 職種名
        foreman_user_name: '', // 職長名
        machinery_name: '', // 機材名
        a_item_name: '', // 作業場所A名
        b_item_name: '', // 作業場所B名
        c_item_name: '', // 作業場所C名
        d_item_name: '', // 作業場所D名
        manager_user_name: '', // 元請担当者名
      },
      formValues: {
        userValueChangeFlag: false, // ユーザー操作フラグ
        approval_flag: APPROVAL_STATUS.unapproved.id, // 承認フラグ
        today_receipt_no: '', // 受付No
        use_date: '', // 作業日
        use_date_start: date_from, // 作業範囲(開始)
        use_date_end: date_from, // 作業範囲(終了)
        field_tree_id: null, // 協力会社ID
        job_id: null, // 職種ID
        foreman_user_id: null, // 職長ID
        spot_company_name: '', // スポット利用会社名
        spot_foreman_user_job: '', // スポット対象職種
        spot_foreman_user_name: '', // スポット利用職長名
        machinery_type: null, // 機材種別
        machinery_id: null, // 機材ID
        company_name: '', // 管理会社
        spec_work_flat_height: '', // 性能
        spec_load: '', // 積載量
        use_start_time: '', // 作業開始時刻
        use_end_time: '', // 作業終了時刻
        spot_flag: SPOT_STATUS.normal.id, // スポット作業ON/OFF
        spot_time: '', // スポット時間
        driver_name: '', // 運転者
        conductor_name: '', // 作業指揮者
        leading_worker_name: '', // 誘導者
        safety_instruction: '', // 安全事項
        a_item_id: null, // 作業場所A
        b_item_id: null, // 作業場所B
        c_item_id: null, // 作業場所C
        d_item_id: null, // 作業場所D
        work_contents: '', // 作業内容
        manager_user_id: null, // 元請担当者ID
        schedule_type: SCHEDULE_TYPES.machinery.id, // 機材予定
        work_hour_zone: SessionStorageService.getItem('work_hour_zone'), // 作業時間帯
        displayFlg: {
          field_item_list1_display_flag: '', // 作業場所1フラグ
          field_item_list2_display_flag: '', // 作業場所2フラグ
          field_item_list3_display_flag: '', // 作業場所3フラグ
          field_item_list4_display_flag: '', // 作業場所4フラグ
        },
      },
      isLinkedIchiPlusMachineryUse: false,
    };

    this.events = {
      form: {
        set: this.setFlatData.bind(this),
        setTime: this.setTime.bind(this), // 開始・終了時間セット
        calender: this.setDate.bind(this),
        machinery: this.setMachineryDropdownData.bind(this),
        submit: this.eventSubmit.bind(this),
        update: this.eventUpdate.bind(this),
        setSpot: this.setSpotFlag.bind(this),
        setSpotStatus: this.setSpotStatus.bind(this),
        validate: this.validate.bind(this), // バリデーション
      },
    };

    this.updatingFlag = false; // 多重更新防止Flag

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.setMachineryDetails = this.setMachineryDetails.bind(this); // 選択した機材情報取得
    this.deleteMachineryUse = this.deleteMachineryUse.bind(this); // 予定削除
    this.checkRequired = this.checkRequired.bind(this); // 必須項目入力状況監視
    this.handleVisibleDialog = this.handleVisibleDialog.bind(this); // ダイアログ開閉設定
  }

  componentWillMount() {
    FieldService.fieldItem(this.state.fieldId).then(resp => {
      if (resp.result) {
        let formValues = { ...this.state.formValues };
        let displayFlg = formValues.displayFlg;
        let field_item = resp.data.entities.field_item;
        _.each(displayFlg, (value, key) => {
          displayFlg[key] = field_item[key];
        });
        formValues.displayFlg = displayFlg;
        this.setState({ formValues });
      }
    });
  }

  /**
   * 現場情報を取得し、作業時間をセット
   */
  componentDidMount() {
    FieldService.info(this.state.fieldId).then(response => {
      if (response.result) {
        const field = response.data.entities.field;
        const field_items = response.data.entities.field.field_items;
        let workTime = this.state.workTime;
        workTime[WORK_HOUR_ZONES.day.id] = _.assign(
          workTime[WORK_HOUR_ZONES.day.id],
          { start: field.work_start_time, end: field.work_end_time }
        );
        workTime[WORK_HOUR_ZONES.night.id] = _.assign(
          workTime[WORK_HOUR_ZONES.night.id],
          { start: field.work_start_time_night, end: field.work_end_time_night }
        );
        workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
          workTime[WORK_HOUR_ZONES.midnight.id],
          {
            start: field.work_start_time_midnight,
            end: field.work_end_time_midnight,
          }
        );

        const item_list_ids = [1, 2, 3, 4];
        _.map(item_list_ids, (itemListId, key) => {
          if (field_items[`field_item_list${itemListId}_display_flag`] === 0) {
            item_list_ids.splice(key, 1);
          }
        });

        if (item_list_ids.length === 0) {
          this.setState({ workTime });
        } else {
          // 作業場所(item_list_ids)項目があれば作業エリア情報取得する
          const params = {
            item_list_ids,
            is_limit: 1,
            offset: 0,
            limit: 30,
            // 有効のものだけ表示
            display_flag: 1,
          };

          // 現場作業エリア情報取得API
          FieldItemService.list(this.state.fieldId, params).then(response => {
            if (response.result === false) {
              return;
            }

            this.setState({
              workTime,
              options: response.data.entities,
              loaded: true,
            });
          });
        }

        if (this.state.machineryUseId > 0) {
          MachineryUseService.show(
            this.state.fieldId,
            this.state.machineryUseId
          ).then(response => {
            if (response.result) {
              const machineryUse = response.data.entities.machinery_use;
              this.initForm(machineryUse);
              if (
                _.some(machineryUse.external_system_machinery_uses, {
                  external_system_type: EXTERNAL_SYSTEM_TYPE.ICHI_PLUS,
                })
              ) {
                this.setState({ isLinkedIchiPlusMachineryUse: true });
              }
            }
          });
        }
      }
    });
    this.getItemListTitle();
  }

  componentDidUpdate(prevProps, prevState) {
    // 機材予定編集画面でスポット業者へ切り替えを行った場合、一度だけ実行
    if (
      prevState.isSpot !== this.state.isSpot &&
      !this.state.isSpotToggle &&
      this.state.isEdit
    ) {
      const pulldownName = { ...this.state.pulldownName };
      delete pulldownName.company_name;
      this.setState({ isSpotToggle: true, pulldownName });
    }
  }

  /**
   * フォーム生成
   * @param data {object} machinery_use
   * @param isCopyLatest {boolean} 前回コピーフラグ
   */
  initForm(data, isCopyLatest = false) {
    // console.log(
    //   'MachineryUseRegister.jsx initForm',
    //   Object.keys(data).join(','),
    //   Object.keys(this.state.formValues).join(','),
    //   Object.keys(this.state.pulldownName).join(',')
    // );

    // if (
    //   !parts.object.inProperty(
    //     data,
    //     'id, field_id, field_tree_id,' +
    //       'company_name_1, company_name_2, company_name_3, company_name_4, company_name_5,' +
    //       'nest_no, machinery_id, use_date, today_receipt_no,' +
    //       'foreman_user_id, foreman_user_name_sei, foreman_user_name_mei, driver_name,' +
    //       'a_item_id, a_item_name, b_item_id, b_item_name, c_item_id, c_item_name, d_item_id, d_item_name,' +
    //       'work_area, conductor_name, leading_worker_name,' +
    //       'use_start_time, use_end_time,' +
    //       'co2_emissions, work_contents,' +
    //       'manager_user_id, manager_user_name,' +
    //       'safety_instruction, work_hour_zone, schedule_type,' +
    //       'spot_flag, spot_time, job_id, job_name, approval_flag,' +
    //       'spot_company_name, spot_foreman_user_name, spot_foreman_user_job,' +
    //       'created_at, updated_at, create_user_id, update_user_id, machinery_type, machinery_name ' +
    //       ''
    //   )
    // ) {
    //   throw new Error('GatePassageEdit.jsx initForm data inProperty');
    // }
    // if (
    //   !parts.object.inProperty(
    //     this.state.formValues,
    //     'userValueChangeFlag, approval_flag, today_receipt_no,' +
    //       'use_date, use_date_start, use_date_end,' +
    //       'field_tree_id, job_id, foreman_user_id,' +
    //       'spot_company_name, spot_foreman_user_job, spot_foreman_user_name,' +
    //       'machinery_type, machinery_id,' +
    //       'company_name,' +
    //       'spec_work_flat_height, spec_load,' +
    //       'use_start_time, use_end_time, spot_flag, spot_time,' +
    //       'driver_name, conductor_name, leading_worker_name, safety_instruction,' +
    //       'a_item_id, b_item_id, c_item_id, d_item_id,' +
    //       'work_contents, manager_user_id, schedule_type, work_hour_zone, displayFlg ' +
    //       ''
    //   )
    // ) {
    //   throw new Error(
    //     'GatePassageEdit.jsx initForm this.state.formValues inProperty'
    //   );
    // }
    // if (
    //   !parts.object.inProperty(
    //     this.state.pulldownName,
    //     'company_name, job_name, foreman_user_name, machinery_name,' +
    //       'a_item_name, b_item_name, c_item_name, d_item_name, manager_user_name' +
    //       ''
    //   )
    // ) {
    //   throw new Error(
    //     'GatePassageEdit.jsx initForm this.state.pulldownName inProperty'
    //   );
    // }

    let formValues = { ...this.state.formValues };
    let pulldownName = { ...this.state.pulldownName };
    _.each(data, (machinery_use, index) => {
      if (_.has(this.state.formValues, index)) {
        formValues[index] = _.isNull(machinery_use) ? '' : machinery_use;
      }
    });

    // プルダウンの名前の初期値を取得
    _.map(pulldownName, (value, key) => {
      pulldownName[key] = _.defaultTo(data[key], null);
    });
    // 一次協力会社以外だった場合カッコ内に協力会社の名前を入れる
    let companyName = data.company_name_1;
    if (data.nest_no > 1) {
      const nestCompany = `company_name_${data.nest_no}`;
      companyName = `${data.company_name_1}(${data[nestCompany]})`;
    }
    pulldownName.company_name = companyName; // 協力会社名
    if (data.private_partner_company_flag) {
      pulldownName.company_name += PRIVATE_PARTNER_COMPANY_LABEL;
    }
    pulldownName.foreman_user_name = data.foreman_user_name_sei
      ? `${data.foreman_user_name_sei} ${data.foreman_user_name_mei}`
      : ''; // 職長名

    // 機材詳細
    this.setMachineryDetails(data.machinery_id);

    // 予定種別
    formValues.schedule_type = SCHEDULE_TYPES.machinery.id;

    let viewOnlyFlag = false;
    // 更新時のみ編集可能かチェック 前回コピーの場合は必ず登録可能
    if (this.state.isEdit) {
      // 協力会社ユーザーの場合、現在日付がpassage_dateより後の日付 || 他社の予定は編集不可とする
      if (
        (isTargetRoleId(USER_ROLES_IDS.PARTNER_COMPANY, this.state.roleId) &&
          moment().isAfter(formValues.use_date, 'days')) ||
        (_.has(data, 'permissions') && data.permissions.edit === false)
      ) {
        viewOnlyFlag = true;
      }
    }

    this.setState(
      {
        formValues,
        pulldownName,
        viewOnlyFlag,
        isFirstLoaded: true,
        isSpot: data.spot_company_flag,
      },
      () => {
        if (isCopyLatest) {
          this.validate();
        } else {
          this.checkRequired(formValues);
        }
      }
    );
  }

  /***
   * @description バリデーションチェック
   * @param {string} name フォーム名
   * @return バリデーションメッセージ数
   */
  validate(name, updateValues = {}) {
    // 編集権限がない場合、エラーチェックは行わない
    if (this.state.viewOnlyFlag) {
      return;
    }
    const checkValues = {
      ...this.state.formValues,
      ...updateValues,
    };
    const values = {};
    _.map(checkValues, (value, index) => {
      values[index] = _.isNull(value) ? '' : `${value}`;
    });

    const schema = this.changeSchema();
    const result = validateByJoi(Joi.object().keys(schema), values);
    const validate = { ...this.state.validate };
    const targetUseDateKey = this.state.isEdit ? 'use_date' : 'use_date_start';
    // エラーメッセージをセット
    if (name) {
      if (_.has(result.messages, name)) {
        validate.messages[name] = result.messages[name];
      } else if (validate.messages[name]) {
        delete validate.messages[name];
      }

      // 日付チェック
      const later = moment(values.use_date_start, 'YYYY/MM/DD').add(30, 'days');
      if (moment(values.use_date_end).isAfter(later)) {
        validate.messages.use_date_start = messageUtility.getMessage(
          'E-001-303'
        );
      } else if (
        moment(values.use_date_start, 'YYYY/MM/DD').isAfter(values.use_date_end)
      ) {
        validate.messages.use_date_start = messageUtility.getMessage(
          'E-001-304'
        );
      } else {
        delete validate.messages.use_date_start;
      }

      // 協力会社ユーザーでログイン時、
      // 開始日(From)が現在日より前の日付に設定されていたらエラー
      const targetUseDate = this.state.isEdit
        ? values.use_date
        : values.use_date_start;
      if (
        isTargetRoleId(USER_ROLES_IDS.PARTNER_COMPANY, this.state.roleId) &&
        moment().isAfter(targetUseDate, 'days')
      ) {
        validate.messages[targetUseDateKey] = messageUtility.getMessage(
          'E-001-313'
        );
        validate.invalid = true;
      }

      if (
        name === 'use_start_time' ||
        name === 'use_end_time' ||
        name === 'spot_time'
      ) {
        validate.messages = this.timeValidateCheck(
          name,
          values,
          validate.messages
        );
      }
    } else {
      if (!isNullOrEmpty(validate.messages[targetUseDateKey])) {
        if (_.has(result, 'messages')) {
          result.messages[targetUseDateKey] =
            validate.messages[targetUseDateKey];
        } else {
          result.messages = {};
          result.messages[targetUseDateKey] =
            validate.messages[targetUseDateKey];
        }
      }
      if (_.size(result.messages) > 0) {
        validate.messages = result.messages;
      } else {
        validate.messages = {};
      }
      validate.messages = this.timeValidateCheck(
        name,
        values,
        validate.messages
      );
    }
    if (Object.keys(validate.messages).length === 0) {
      validate.invalid = false;
    } else {
      validate.invalid = true;
    }
    this.setState({ validate });
    // 必須チェック
    this.checkRequired(values);
    return Object.keys(validate.messages).length;
  }

  changeSchema() {
    // 基本項目
    let schema = {
      approval_flag: Joi.string().allow(null, ''), // 承認フラグ
      today_receipt_no: Joi.string()
        .allow(null, '')
        .max(255), // 受付番号
      use_date_start: Joi.string().allow(null, ''), // 開始日
      use_date_end: Joi.string().allow(null, ''), // 終了日
      use_date: Joi.string().allow(null, ''), // 作業日
      field_tree_id: Joi.string().allow(null, ''), // 協力会社ID
      job_id: Joi.string().allow(null, ''), // 職種
      foreman_user_id: Joi.string().allow(null, ''), // 職長
      spot_company_name: Joi.string()
        .max(255)
        .allow(null, ''), // スポット利用会社名
      spot_foreman_user_job: Joi.string()
        .max(255)
        .allow(null, ''), // スポット対象職種
      spot_foreman_user_name: Joi.string()
        .max(255)
        .allow(null, ''), // スポット利用職長名
      machinery_type: Joi.string().required(), // 機材種別
      machinery_id: Joi.string().required(), // 機材ID
      company_name: Joi.string().allow(null, ''), // 管理会社名
      spec_work_flat_height: Joi.string().allow(null, ''), // オペレーター
      spec_load: Joi.string().allow(null, ''), // 性能
      use_start_time: Joi.string().allow(null, ''), // 開始時間
      use_end_time: Joi.string().allow(null, ''), // 終了時間
      spot_flag: Joi.number().allow(null, ''), // スポット作業ON/OFF
      spot_time: Joi.string().allow(null, ''), // スポット時間
      driver_name: Joi.string()
        .max(255)
        .allow(null, ''), // 運転者
      conductor_name: Joi.string()
        .max(255)
        .allow(null, ''), // 作業指揮者
      leading_worker_name: Joi.string()
        .max(255)
        .allow(null, ''), // 誘導者
      safety_instruction: Joi.string()
        .max(255)
        .allow(null, ''), // 安全事項
      a_item_id: Joi.string().allow(null, ''), // 作業場所A
      b_item_id: Joi.string().allow(null, ''), // 作業場所B
      c_item_id: Joi.string().allow(null, ''), // 作業場所C
      d_item_id: Joi.string().allow(null, ''), // 作業場所D
      work_contents: Joi.string()
        .max(255)
        .allow(null, ''), // 作業内容
      manager_user_id: Joi.string().allow(null, ''), // 元請担当者
      schedule_type: Joi.string().required(), // ゲート予定
      work_hour_zone: Joi.string().required(), // 作業時間帯
    };
    // スポット業者
    if (this.state.isSpot) {
      schema.spot_company_name = Joi.string()
        .max(255)
        .required(); // スポット利用会社名
    } else {
      schema.field_tree_id = Joi.string().required(); // 協力会社ID
    }
    return schema;
  }

  /***
   * @description 時間、スポット時間バリデーションチェック
   * @param {string} name フォーム名
   * @param {object} values 全入力値
   * @param {object} validateMessage 格納しているエラーメッセージ
   */
  timeValidateCheck(name, values, validateMessage) {
    // 必須チェック
    if (name !== 'spot_time') {
      if (values.use_start_time === '' || values.use_end_time === '') {
        validateMessage.use_time = messageUtility.getMessage('E-000-010');
        delete validateMessage.spot_time;
      } else {
        delete validateMessage.use_time;
      }
    }

    return validateMessage;
  }

  /**
   * 必須入力状況チェック
   * @param values {object} 入力値
   */
  checkRequired(values) {
    // 必須チェック
    let requiredInput = this.state.requiredInput;
    let cnt = 0;
    const columns = this.state.isSpot
      ? requiredInput.hasSpot
      : requiredInput.columns;
    _.each(columns, column => {
      if (
        column === 'use_time' &&
        !_.isEmpty(values['use_start_time']) &&
        !_.isEmpty(values['use_end_time'])
      ) {
        // 時間の開始、終了時間がどちらも入力されている時のみカウント++
        cnt++;
      } else if (!isNullOrEmpty(values[column])) {
        cnt++;
      }
    });
    requiredInput.count = cnt;
    requiredInput.total = _.size(columns);

    this.setState({ requiredInput });
  }

  /**
   * 入力値をformValuesにセット
   */
  setFlatData = (name, value) => {
    if (
      name === 'machinery_id' &&
      this.state.formValues.machinery_id !== value
    ) {
      this.setMachineryDropdownData(name, value);
      return;
    }

    this.setState(prevState => {
      const formValues = _.cloneDeep(prevState.formValues);
      formValues[name] = deleteControlCode(value);

      // 機材予定 の編集画面で
      // 協力会社Dropdownが動作した時に
      // 職種Dropdown 職長Dropdown の初期化が行われる
      // 不具合[BLDE_V2-17211]として、内部値が更新されていない問題があり
      // この箇所で内部値をクリアしておく

      // 協力会社:field_tree_id
      // 職種:job_id
      // 職長:foreman_user_id
      if (
        name === 'field_tree_id' &&
        this.state.formValues.field_tree_id !== value
      ) {
        // 協力会社に変更があった場合は、職種|職長の値は初期化される
        formValues.job_id = null;
        formValues.foreman_user_id = null;
        formValues.userValueChangeFlag = true;
      } else if (name === 'job_id' && this.state.formValues.job_id !== value) {
        // 職種に変更があった場合は、職長の値は初期化される
        formValues.foreman_user_id = null;
        formValues.userValueChangeFlag = true;
      }

      return {
        formValues,
      };
    });
  };

  /**
   * 入力値をformValuesにセット
   */
  setTime = e => {
    const selectedIndex = e.target.selectedIndex;
    const selected = e.target.options[selectedIndex];
    const selectedDate = selected.getAttribute('data-select');
    const target = moment(selectedDate);
    let formValues = this.state.formValues;
    const name = e.target.name;
    const value = e.target.value;
    formValues[name] = value;
    if (name === 'use_start_time') {
      if (!formValues.use_end_time) {
        formValues.use_end_time = target.add(15, 'minutes').format('HH:mm:ss');
      } else {
        const endSelect = document.getElementById(
          'machinery-uses-use-end-time'
        );
        const endIndex = endSelect.selectedIndex;
        const endSelected = endSelect.options[endIndex];
        const end = moment(endSelected.getAttribute('data-select'));
        if (end.isSameOrBefore(target)) {
          formValues.use_end_time = target
            .add(15, 'minutes')
            .format('HH:mm:ss');
        }
      }
    } else if (name === 'use_end_time') {
      if (!formValues.use_start_time) {
        formValues.use_start_time = target
          .add(-15, 'minutes')
          .format('HH:mm:ss');
      } else {
        const startSelect = document.getElementById(
          'machinery-uses-use-start-time'
        );
        const startIndex = startSelect.selectedIndex;
        const startSelected = startSelect.options[startIndex];
        const start = moment(startSelected.getAttribute('data-select'));
        if (start.isSameOrAfter(target)) {
          formValues.use_start_time = target
            .add(-15, 'minutes')
            .format('HH:mm:ss');
        }
      }
    }
    this.setState({ formValues });
  };

  /**
   * カレンダー日付セット
   * @param name {string}
   * @param date {string}
   */
  setDate = (name, date) => {
    const formValues = { ...this.state.formValues };
    if (formValues[name] !== date) {
      formValues[name] = date;
      this.validate(name, { [name]: date });
      this.setState({ formValues });
    }
  };

  /**
   * ドロップダウンで選択した機材情報をstateへ保存
   * @param name {string}
   * @param value {int}
   */
  setMachineryDropdownData = (name, value) => {
    if (value) {
      this.setState(
        prevState => ({
          formValues: {
            ...prevState.formValues,
            machinery_id: value,
          },
        }),
        () => {
          this.setMachineryDetails(value);
        }
      );
    } else {
      this.setState(prevState => ({
        formValues: {
          ...prevState.formValues,
          machinery_id: value,
          spec_work_flat_height: '',
          spec_load: '',
          company_name: '',
        },
      }));
    }
  };

  /**
   * スポット業者設定ハンドリング
   * @param spotFlag {int}
   */
  setSpotFlag = spotFlag => {
    let formValues = this.state.formValues;
    let isSpot = this.state.isSpot;
    let validate = this.state.validate;
    if (spotFlag === SPOT_STATUS.spot.id) {
      formValues.field_tree_id = null;
      formValues.job_id = null;
      formValues.foreman_user_id = null;
      if (validate.messages.field_tree_id) {
        delete validate.messages.field_tree_id;
      }
      isSpot = true;
    } else if (spotFlag === SPOT_STATUS.normal.id) {
      formValues.spot_company_name = '';
      formValues.spot_foreman_user_job = '';
      formValues.spot_foreman_user_name = '';
      if (validate.messages.spot_company_name) {
        delete validate.messages.spot_company_name;
      }
      isSpot = false;
    }
    if (Object.keys(validate.messages).length === 0) {
      validate.invalid = false;
    }

    this.setState({
      formValues,
      isSpot,
      validate,
    });
  };

  /**
   * スポットフラグ設定
   * @param checked {boolean}
   */
  setSpotStatus = checked => {
    if (this.state.formValues.approval_flag === APPROVAL_STATUS.approval.id) {
      return;
    }
    let formValues = { ...this.state.formValues };
    let validate = { ...this.state.validate };
    if (checked) {
      formValues.spot_flag = SPOT_STATUS.normal.id;
      formValues.spot_time = '';
      validate.messages = this.timeValidateCheck(
        'spot_time',
        formValues,
        validate.messages
      );
      if (_.isEmpty(validate.messages)) {
        validate.invalid = false;
      }
    } else {
      formValues.spot_flag = SPOT_STATUS.spot.id;
      formValues.spot_time = SPOT_TIMES_DEFAULT;
    }

    this.setState({ formValues, validate });
  };

  /**
   * 機材マスタ情報セット
   * @param machineryId {int}
   */
  setMachineryDetails(machineryId) {
    MachineryService.show(this.state.fieldId, machineryId).then(response => {
      if (response.result) {
        const machinery = response.data.entities.machinery;
        this.setState(prevState => ({
          formValues: {
            ...prevState.formValues,
            spec_work_flat_height: machinery.spec_work_flat_height,
            spec_load: machinery.spec_load,
            company_name: machinery.company_name,
          },
        }));
      }
    });
  }

  /**
   * 前回コピー
   */
  getLatestMachineryUse() {
    MachineryUseService.latestRegistration(this.state.fieldId, {
      work_hour_zone: SessionStorageService.getItem('work_hour_zone'),
      date: this.state.formValues.use_date_start,
    }).then(response => {
      if (response.result) {
        if (_.isEmpty(response.data.entities.machinery_use)) {
          alert(messageUtility.getMessage('E-000-013'));
        } else {
          let machineryUse = _.cloneDeep(response.data.entities.machinery_use);
          machineryUse.approval_flag = APPROVAL_STATUS.unapproved.id;
          this.initForm(machineryUse, true);
        }
      } else {
        const message = _.get(response, 'data.message');
        if (isCopyLatestError(message)) {
          return dialogLoader.show(FormInformationDialog, {
            title: messageUtility.getMessage('E-001-402'),
            message,
            onClose: () => {
              dialogLoader.close();
            },
          });
        }
      }
    });
    this.setState({ visibleDialogName: null });
  }

  /**
   * 登録
   */
  eventSubmit = () => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    let validate = this.validate();
    if (validate !== 0) {
      this.updatingFlag = false;
      return;
    }
    MachineryUseService.create(this.state.fieldId, this.state.formValues).then(
      response => {
        this.onSaveCompleted(response, false);
      }
    ).finally(() => {
      this.updatingFlag = false;
    });
  };

  /**
   * 更新
   */
  eventUpdate = () => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    let validate = this.validate();
    if (validate !== 0) {
      this.updatingFlag = false;
      return;
    }
    MachineryUseService.update(this.state.fieldId, this.state.machineryUseId, {
      ...this.state.formValues,
      from_machinery_use_edit: 1,
    }).then(response => {
      this.onSaveCompleted(response, true);
    }).finally(() => {
      this.updatingFlag = false;
    });
  };

  onSaveCompleted = (response, isEdit) => {
    if (response.message) {
      if (isWorkDateError(response.message)) {
        const validate = _.cloneDeep(this.state.validate);
        if (isEdit) {
          validate.messages.use_date = response.message;
        } else {
          validate.messages.use_date_start = response.message;
        }
        validate.invalid = true;
        this.setState({ validate });
      } else {
        if (isPrimeContractorHasBlockedOrFinishedWorkError(response.message)) {
          return dialogLoader.show(FormInformationDialog, {
            title: messageUtility.getMessage('E-001-422'),
            message: messageUtility.getMessage('E-001-423'),
            onClose: () => {
              window.location.reload();
            },
          });
        }
        dialogLoader.show(ErrorDialog, {
          message: response.message,
          callback: {
            close: () => {
              dialogLoader.close();
            },
          },
        });
      }
    } else if (response.result) {
      _slideLoader.close(this.props.vw);
      EventMg.trigger(MY_EVENT.LOAD_MACHINERY_USES_DATA);
    }
  };

  /**
   * 機材予定削除
   */
  deleteMachineryUse() {
    MachineryUseService.deleteSchedule(
      this.state.fieldId,
      this.state.machineryUseId
    ).then(response => {
      if (response.result) {
        _slideLoader.close(this.props.vw);
        EventMg.trigger(MY_EVENT.LOAD_MACHINERY_USES_DATA);
      }
    });
  }

  getItemListTitle() {
    FieldItemInputService.itemNames(this.state.fieldId).then(itemNames =>
      this.setState({ itemNames })
    );
  }

  /**
   * @description ダイアログ開閉設定
   * @param {string} dialogName ダイアログ名(DIALOG_NAME)
   *                            ※ nullの場合は、ダイアログを閉じる
   */
  handleVisibleDialog(dialogName) {
    this.setState({ visibleDialogName: dialogName });
  }

  render() {
    const {
      visibleDialogName,
      isFirstLoaded,
      viewOnlyFlag,
      formValues,
      isLinkedIchiPlusMachineryUse,
    } = this.state;

    const createPageTitle = ({ isEdit, approved }) => {
      if (!isEdit) {
        return '機材予定新規作成';
      }
      if (!isFirstLoaded) {
        return '';
      }
      switch (approved) {
        case APPROVAL_STATUS.approval.id:
          return '承認済機材予定';
        case APPROVAL_STATUS.unapproved.id:
          return '機材予定編集';
        default:
          return '';
      }
    };
    const pageTitle = createPageTitle({
      isEdit: this.state.isEdit,
      approved: formValues.approval_flag,
    });

    return (
      <div className='slide-view show'>
        <Helmet>
          <title>{`${HEADER_CONSTANTS.conference} - ${pageTitle}`}</title>
        </Helmet>
        <div className='slide-view__view'>
          <MachineryUseRegisterHeader
            isEdit={this.state.isEdit}
            isFirstLoaded={isFirstLoaded}
            viewOnlyFlag={viewOnlyFlag}
            callbacks={this.events}
            approved={formValues.approval_flag}
            onVisibleDialog={this.handleVisibleDialog}
            pageTitle={pageTitle}
            validate={this.state.validate}
            requiredInput={this.state.requiredInput}
            vw={this.props.vw}
            isLinkedIchiPlusMachineryUse={isLinkedIchiPlusMachineryUse}
          />
          <MachineryUseForm
            roleId={this.state.roleId}
            isEdit={this.state.isEdit}
            isSpot={this.state.isSpot}
            isSpotToggle={this.state.isSpotToggle}
            values={formValues}
            errors={this.state.validate}
            workTime={this.state.workTime}
            viewOnlyFlag={
              formValues.approval_flag === APPROVAL_STATUS.approval.id ||
              viewOnlyFlag
            }
            events={this.events}
            itemNames={this.state.itemNames}
            onVisibleDialog={() => this.handleVisibleDialog(DIALOG_NAME.copy)}
            pulldownName={this.state.pulldownName}
            options={this.state.options}
            loaded={this.state.loaded}
            isLinkedIchiPlusMachineryUse={isLinkedIchiPlusMachineryUse}
          />
        </div>
        <Confirmation
          title={messageUtility.getMessage('I-000-025')}
          visible={visibleDialogName === DIALOG_NAME.close}
          message={messageUtility.getMessage('I-000-confirmCloseEditWindow')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={() => {
            _slideLoader.close(this.props.vw);
            EventMg.trigger(MY_EVENT.LOAD_MACHINERY_USES_DATA, true);
          }}
          onCancel={() => this.handleVisibleDialog(null)}
          negativeButtonClassName='btn--negative'
          cancelButtonClassName='btn--sub'
        />
        <Confirmation
          visible={visibleDialogName === DIALOG_NAME.delete}
          title={messageUtility.getMessage(
            'I-001-302',
            SCHEDULE_TYPES.machinery.name
          )}
          message={messageUtility.getMessage('W-000-003')}
          confirmButtonText={messageUtility.getMessage('I-000-018')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={() => {
            this.deleteMachineryUse();
          }}
          onCancel={() => this.handleVisibleDialog(null)}
        />
        <Confirmation
          visible={visibleDialogName === DIALOG_NAME.copy}
          title={messageUtility.getMessage('I-001-303')}
          message={messageUtility.getMessage('W-001-301')}
          confirmButtonText={messageUtility.getMessage('I-000-019')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() => {
            this.getLatestMachineryUse();
          }}
          onCancel={() => this.handleVisibleDialog(null)}
        />
      </div>
    );
  }
}

/**
 * 登録・更新ヘッダー
 */
const MachineryUseRegisterHeader = ({
  isEdit,
  isFirstLoaded,
  viewOnlyFlag,
  callbacks,
  approved,
  onVisibleDialog,
  pageTitle,
  validate,
  requiredInput,
  vw,
  isLinkedIchiPlusMachineryUse,
}) => {
  return (
    <ConferencePageHeader
      title={pageTitle}
      leftComponent={
        isEdit ? (
          <React.Fragment>
            {approved !==
            APPROVAL_STATUS.unapproved
              .id ? null : !isFirstLoaded ? null : viewOnlyFlag ? null : (
              <React.Fragment>
                <button
                  className='btn--effective slide-view__header--button'
                  onClick={() => callbacks.form.update()}
                >
                  更新
                </button>
                {!isLinkedIchiPlusMachineryUse && (
                  <button
                    id='open-confirm-close'
                    className='btn--negative slide-view__header--button'
                    onClick={() => onVisibleDialog(DIALOG_NAME.delete)}
                  >
                    削除
                  </button>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        ) : (
          <button
            id='open-confirm-close'
            className='btn--effective slide-view__header--button'
            onClick={() => callbacks.form.submit()}
          >
            登録
          </button>
        )
      }
      rightComponent={
        <React.Fragment>
          <div className='slide-view__header-end-item'>
            <div className='form-list__header-alert show'>
              {validate.invalid ? messageUtility.getMessage('E-000-014') : ''}
            </div>
          </div>
          <div className='slide-view__header-end-item'>
            {`必須項目の入力数 ${requiredInput.count}/${requiredInput.total}`}
          </div>
        </React.Fragment>
      }
      onClose={() =>
        approved !== APPROVAL_STATUS.unapproved.id
          ? _slideLoader.close(vw)
          : onVisibleDialog(DIALOG_NAME.close)
      }
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/MachineryUseRegister.jsx